var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 678",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31.7461 984.631H187.05L387.482 776.006L588.041 985H808.38L387.128 546.383L-31.7461 984.631Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.073 -224.628H593.011L390.552 -14.0434L187.939 -225H-34.6562L390.909 217.735L814.073 -224.628Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.15 705.847V587.219L760.793 376.502L963.508 165.678V48.9648L852.607 49.4701L538.07 376.874L852.53 702.656L963.15 705.847Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-195.642 48.9648V167.62L6.71475 378.337L-196 589.16V705.847L-85.0729 705.369L229.463 377.965L-84.9962 52.1825L-195.642 48.9648Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkTablet);
export default __webpack_public_path__ + "static/media/watermark-tablet.a2431c3d0b9033f735641a7cc63bebfb.svg";
export { ForwardRef as ReactComponent };